import WillgoLogo from '../WillgoLogo.png'; 

const AgentNotFoundHeader = () => {
    return <div style={{padding: 10, backgroundColor: "black", position: "fixed", top: 0, left: 0, width: "100vw"}}>
        <div className="wrapper">
            <div style={{display: "flex", padding: 10, alignItems: "center"}}>
                <p className="footer-site-logo">
                    <span style={{fontSize: 13, color: "yellow", fontWeight: "bolder", marginRight: 5}}>
                        Powered by</span>
                    <img src={WillgoLogo}/></p>
                <p style={{fontWeight: "bolder", fontSize: 13, marginLeft: 2, color: "white", textAlign: "center", letterSpacing: 0.5, fontFamily: "Courgette"}}>
                    welldugo.com</p>
            </div>
            <p style={{color: "skyblue", fontSize: 13, fontFamily: "courier"}}>
                <i style={{marginRight: 10, color: "yellow"}} className="fa-solid fa-robot"></i>
                Hey, I counld not find any agent for your request...!
                <span className="blinking_cursor" style={{borderLeft: "2px solid white", fontSize: 20, borderTopColor: "white", borderRightColor: "white", borderBottomColor: "white"}}></span>
            </p>
        </div>
    </div>
}

export default AgentNotFoundHeader;